import { DisclaimerAccessValidator } from './disclaimerAccessValidator.js';
export class Disclaimer {
    init() {
        const self = this;
        let disclaimerAccessValidator = new DisclaimerAccessValidator();

		$('#settingsDisclaimerButton').on('click', function(e) {
			e.preventDefault();
			$('#disclaimerModal').modal('show');
		})
		$('#disclaimerModal .dropdown-menu.profile label').each(function() {
			$(this).on('click', function() {
				document.getElementById('profileDropdown').innerText = this.innerText;
			})
		})

		if(document.getElementById('disclaimerModal')){
			$("#disclaimerModal #countrySelect").select2({
				templateResult: self.formatCountriesResults,
				templateSelection: self.formatCountriesSelect,
				dropdownCssClass : 'wide',
				dropdownParent: $("#countryDropdownArea")
			});
		}

		$('#disclaimerModalDismiss').on('click', function() {
            let profile = document.getElementById('profileDropdown').innerText;
            let country = document.getElementById('countrySelect').value;

			if(profile !== 'Choose investor profile'){
				$('#disclaimerModal').modal('hide');

				profile == 'Retail' ? $('h5.retail').removeClass('d-none') : $('h5.inst-prof').removeClass('d-none');

                // If selected country is Luxembourg, show disclaimerCountryLuxModal modal
                if (disclaimerAccessValidator.isLuxembourg(country)){
                    $('#disclaimerCountryLuxModal').modal('show');
                }
                // If selected country is not in the countriesWithAccess array, show disclaimerCountryModal modal
                else if (disclaimerAccessValidator.hasAccess(country) === false) {
					$('#disclaimerCountryModal').modal('show');
				}
			}
		})
		$('#apiSettingsChange').on('click', function() {
			$.ajax({
				type: "POST",
                url: $(this).data('url'),
                data: {
                	country: document.getElementById('countrySelect').value,
                	investor_profile: $('#profileDropdown').html()
                }
            }).success(function(data) {
            	window.location = window.location;
            })
		});
	}
	formatCountriesResults (country) {
		if (!country.id) {
			return country.text;
		}
		var baseUrl = "assets/front/images/disclaimer-icons";
		var $country = $(
			'<span>' + country.text + '<img src="'+ country.element.dataset.flag+ '" class="img-flag" /></span>'
		);
		return $country;
	}
	formatCountriesSelect (country){
		if (!country.id) {
			return country.text;
		}
		var baseUrl = "assets/front/images/disclaimer-icons";
		var $country = $(
			'<span><span></span><img class="img-flag ml-2" alt="" /></span>'
		);

		$country.find("span").text(country.text);
		$country.find("img").attr("src", country.element.dataset.flag);

		return $country;
	}
}